const helpContent = {
  business_resumen: {
    title: 'Resumen de tu negocio',
    description: 'Ficha de tu negocio (nombre, vertical, horario, configuración) y tu perfil de usuario. Los indicadores del día a día (ventas, leads, IA) ahora viven en el Dashboard principal.',
    whatItDoesNot: 'No es un panel de métricas — solo información de configuración y estado del onboarding.',
    fields: {},
  },
  training: {
    title: 'Estudio de Entrenamiento IA',
    description: 'Configura la personalidad, tono e instrucciones del asistente IA de tu negocio. Aquí defines cómo se comporta el bot al interactuar con tus clientes.',
    whatItDoesNot: 'No genera respuestas por sí solo — necesita Habilidades (Skills) y Conocimiento (Knowledge) para ser útil.',
    fields: {
      assistant_name: { label: 'Nombre del asistente', help: 'El nombre con el que el bot se identifica ante los clientes. Ej: "Sofía", "Asistente de Clínica Dental".' },
      tone: { label: 'Tono', help: 'Define la personalidad del asistente: formal, amigable, técnico, empático. Afecta todas las respuestas.' },
      objectives: { label: 'Objetivos', help: 'Lista de metas que el bot intentará cumplir. Ej: "Agendar citas", "Resolver dudas sobre precios".' },
      guardrails: { label: 'Guardarraíles', help: 'Límites explícitos. Ej: "No dar diagnósticos médicos", "No compartir precios de competidores".' },
      system_prompt_template: { label: 'Prompt del sistema', help: 'Instrucciones internas que recibe el modelo de IA. Solo visible para administradores — nunca se muestra al cliente.' },
      channel_rules: { label: 'Reglas por canal', help: 'Configura comportamiento diferente para WhatsApp, web, email, etc. Ej: "En WhatsApp, ser más breve".' },
    },
  },
  knowledge: {
    title: 'Biblioteca de Conocimiento',
    description: 'Sube documentos (PDF, Word, texto) que el asistente usará para responder preguntas. El sistema extrae fragmentos, los indexa y los usa como contexto en la IA (RAG).',
    whatItDoesNot: 'No genera respuestas inventadas — si no encuentra evidencia en los documentos, responde "No tengo información suficiente".',
    fields: {
      asset_type: { label: 'Tipo de activo', help: 'Categoriza el documento: manual, FAQ, catálogo, política, etc. Ayuda a filtrar búsquedas.' },
      visibility: { label: 'Visibilidad', help: '"internal_only" = solo el bot y admins. "shareable" = puede compartirse con clientes vía link.' },
      allowed_channels: { label: 'Canales permitidos', help: 'Restringe en qué canales (WhatsApp, web, etc.) el bot puede usar este documento.' },
      embeddings: { label: 'Embeddings', help: 'Representación numérica del texto para búsqueda semántica. Se genera automáticamente al subir.' },
      share_preview: { label: 'Vista previa compartible', help: 'Link público temporal para que un cliente consulte el documento sin login.' },
    },
  },
  skills: {
    title: 'Constructor de Habilidades IA',
    description: 'Define capacidades específicas que el asistente puede ejecutar. Cada habilidad conecta conocimiento, formato de respuesta y nivel de riesgo.',
    whatItDoesNot: 'No ejecuta acciones reales — define QUÉ puede hacer el bot. La ejecución se controla en el Orchestrator.',
    fields: {
      skill_type: { label: 'Tipo de habilidad', help: 'qa = preguntas y respuestas. task = ejecución de tarea. classification = clasificar input.' },
      knowledge_scope: { label: 'Alcance de conocimiento', help: 'Qué documentos de la Biblioteca puede usar esta habilidad. Limita el contexto del bot.' },
      risk_level: { label: 'Nivel de riesgo', help: 'low = informativo. medium = puede afectar flujos. high/critical = requiere aprobación manual.' },
      expected_output_format: { label: 'Formato de salida', help: 'JSON, texto libre, lista, etc. Define cómo el bot estructura su respuesta.' },
      simulate: { label: 'Simular', help: 'Prueba la habilidad sin efectos reales. Verifica el contexto y formato antes de publicar.' },
    },
  },
  tools: {
    title: 'Herramientas que la IA puede ejecutar',
    description: 'Activa acciones reales (agendar citas, consultar clientes, etc.) con interruptores simples por canal. No necesitas escribir código ni JSON.',
    whatItDoesNot: 'Las herramientas integradas no usan el Orchestrator técnico. El modo avanzado (JSON) sigue siendo solo declaración — la ejecución real va por las herramientas integradas de arriba.',
    fields: {
      input_schema: { label: 'Esquema de entrada', help: 'JSON Schema que define qué parámetros recibe la herramienta. Ej: {"query": "string"}.' },
      output_schema: { label: 'Esquema de salida', help: 'JSON Schema que define la estructura de la respuesta esperada.' },
      execution_mode: { label: 'Modo de ejecución', help: 'dry_run = solo validación. future_action = disponible para ejecución futura vía Orchestrator.' },
      approval_mode: { label: 'Modo de aprobación', help: 'none = sin aprobación. human_required = un humano debe aprobar antes de ejecutar.' },
      risk_level: { label: 'Nivel de riesgo', help: 'high/critical = requiere aprobación obligatoria en el Orchestrator antes de ejecutar.' },
      validate: { label: 'Validar (dry-run)', help: 'Prueba el esquema y permisos sin ejecutar nada. Verifica que todo está correcto antes de publicar.' },
    },
  },
  mcp: {
    title: 'Centro de Conectores MCP',
    description: 'Registra servidores externos que siguen el protocolo MCP (Model Context Protocol). Sincroniza sus herramientas, recursos y prompts para mapearlos a tu catálogo.',
    whatItDoesNot: 'No ejecuta herramientas MCP — solo las descubre y registra. La ejecución se hace en el Orchestrator.',
    fields: {
      transport: { label: 'Transporte', help: 'Protocolo de comunicación: HTTP, SSE, Streamable HTTP. stdio está bloqueado en SaaS.' },
      base_url: { label: 'URL base', help: 'Dirección del servidor MCP. URLs locales (localhost, 127.0.0.1, IPs privadas) están bloqueadas por seguridad.' },
      auth_mode: { label: 'Autenticación', help: 'Cómo autenticarse: ninguna, Bearer token, API key. Las credenciales se gestionan en Integraciones.' },
      test_connection: { label: 'Probar conexión', help: 'Verifica que el servidor MCP responde. No ejecuta herramientas — solo handshake.' },
      sync: { label: 'Sincronizar', help: 'Descubre herramientas, recursos y prompts del servidor MCP. Actualiza el catálogo local.' },
      map_to_ai_tool: { label: 'Mapear a herramienta IA', help: 'Vincula una herramienta MCP con una definición del catálogo de Tools. Permite ejecutarla vía Orchestrator.' },
    },
  },
  orchestrator: {
    title: 'Action Orchestrator',
    description: 'Ejecuta herramientas de forma manual y gobernada. Es la 6ª capa del sistema IA — la primera que realmente ejecuta acciones. Controla aprobaciones, timeouts, redacción de datos sensibles y auditoría.',
    whatItDoesNot: 'No tiene triggers automáticos ni AI Chat productivo. Toda ejecución es iniciada manualmente por un usuario autorizado.',
    fields: {
      environment: { label: 'Entorno', help: 'sandbox = pruebas sin consecuencias reales. production = ejecución real (requiere plan habilitado).' },
      dry_run: { label: 'Dry run', help: 'Simula la ejecución: valida permisos, esquemas y plan sin ejecutar nada. Ideal para verificar antes de ejecutar.' },
      execute: { label: 'Ejecutar', help: 'Inicia la ejecución real de la herramienta. Si es high/critical, primero se crea como "pendiente de aprobación".' },
      approve: { label: 'Aprobar', help: 'Solo aprueba — NO ejecuta automáticamente. Después de aprobar, debes hacer click en "Ejecutar aprobado".' },
      execute_approved: { label: 'Ejecutar aprobado', help: 'Ejecuta un run previamente aprobado. Solo disponible si el status es "approved".' },
      risk_level: { label: 'Nivel de riesgo', help: 'high/critical = requiere aprobación antes de ejecutar. low/medium = ejecución directa.' },
    },
  },
  campaigns: {
    title: 'Campaign Builder',
    description: 'Diseña, versiona y aprueba campañas comerciales antes de enviarlas. Define contenido por canal, usa variables y genera previews sin envío real.',
    whatItDoesNot: 'No envía campañas, no programa entregas, no segmenta audiencias reales. Solo diseña y aprueba.',
    fields: {
      key: { label: 'Key', help: 'Identificador único de la campaña dentro de tu tenant. No puede cambiarse después de crear.' },
      name: { label: 'Nombre', help: 'Nombre descriptivo de la campaña. Visible en listas y reportes.' },
      objective: { label: 'Objetivo', help: 'Meta de la campaña: captar leads, fidelizar, informar. Ayuda a evaluar resultados futuros.' },
      campaign_type: { label: 'Tipo', help: 'promotional = ventas/ofertas. informational = novedades. reminder = recordatorios. follow_up = seguimiento.' },
      planned_channels: { label: 'Canales planeados', help: 'Canales donde se enviará en el futuro (WhatsApp, Email, SMS, Social). En S15A solo se diseña contenido.' },
      tone: { label: 'Tono', help: 'Personalidad del mensaje: amigable, formal, urgente. Puede referenciar el tono del AI Training Profile.' },
      risk_level: { label: 'Riesgo', help: 'Nivel de riesgo de la campaña. high = requiere aprobación antes de enviar en el futuro.' },
      content_body: { label: 'Cuerpo del contenido', help: 'Texto del mensaje. Usa {{variables}} que se sustituyen en preview con ejemplos.' },
    },
  },
  contacts: {
    title: 'Contactos',
    description: 'Gestiona los contactos de tu negocio. Cada contacto tiene identidades por canal (email, teléfono, WhatsApp) y consentimiento explícito por canal.',
    whatItDoesNot: 'No es un CRM completo — no gestiona pipeline, deals ni scoring. Solo almacena datos de contacto y consentimiento.',
    fields: {
      contact_type: { label: 'Tipo', help: 'prospect = posible cliente. customer = cliente activo. lead = interesado por calificar.' },
      primary_email: { label: 'Email', help: 'Email principal del contacto. Se normaliza automáticamente (lowercase, trim).' },
      primary_phone: { label: 'Teléfono', help: 'Teléfono principal. Se normaliza a formato numérico para detección de duplicados.' },
      preferred_channel: { label: 'Canal preferido', help: 'Canal por el que el contacto prefiere ser contactado.' },
      consent: { label: 'Consentimiento', help: 'Estado por canal: unknown (default al crear), opted_in (aceptó), opted_out (rechazó). Debe respetarse antes de enviar.' },
      lifecycle_status: { label: 'Estado', help: 'active = contacto vigente. archived = ya no se usa en campañas.' },
      tags: { label: 'Tags', help: 'Etiquetas libres para clasificar contactos. Ej: "VIP", "nuevo", "inactivo".' },
      source_type: { label: 'Origen', help: 'Cómo llegó el contacto: manual, lead_source, import_future.' },
    },
  },
  audiences: {
    title: 'Audiencias',
    description: 'Agrupa contactos en audiencias estáticas para vincularlas a campañas. Muestra resumen de consentimiento por canal.',
    whatItDoesNot: 'No envía mensajes ni segmenta dinámicamente. Solo agrupa contactos y calcula consent summary.',
    fields: {
      key: { label: 'Key', help: 'Identificador único de la audiencia.' },
      audience_type: { label: 'Tipo', help: 'static = miembros agregados manualmente. dynamic_future = segmentación automática en el futuro.' },
      estimated_count: { label: 'Miembros', help: 'Conteo de miembros activos. Se recalcula automáticamente al agregar/remover.' },
      consent_summary: { label: 'Resumen consentimiento', help: 'Distribución de opted_in / opted_out / unknown por canal para toda la audiencia.' },
    },
  },
  schedules: {
    title: 'Programación de Campañas',
    description: 'Define cuándo y bajo qué condiciones podría enviarse una campaña, sin ejecutar ningún envío.',
    whatItDoesNot: 'No envía mensajes, no dispara delivery, no ejecuta colas. Solo planifica y valida condiciones.',
    fields: {
      planned_channel: { label: 'Canal planeado', help: 'Canal futuro de envío: whatsapp_future, email_future, sms_future, social_future, generic.' },
      planned_start_at: { label: 'Fecha inicio', help: 'Cuándo se planea iniciar el envío.' },
      environment: { label: 'Entorno', help: 'sandbox = pruebas. production_future = marcado para producción real en el futuro.' },
      consent_policy: { label: 'Política de consentimiento', help: 'opted_out=block, unknown=warning o block, opted_in=allow.' },
      preflight: { label: 'Preflight', help: '15 validaciones antes de marcar listo.' },
      mark_ready: { label: 'Marcar listo', help: 'Cambia a ready_for_delivery_future. NO envía nada.' },
      audience_snapshot: { label: 'Snapshot de audiencia', help: 'Copia formal de los miembros elegibles. Sin PII.' },
    },
  },
  delivery: {
    title: 'Entregas de Campañas',
    description: 'Crea delivery plans, ejecuta dry-runs y test-sends controlados a contactos test. No envía a toda la audiencia.',
    whatItDoesNot: 'No envía masivamente, no lanza campañas a producción (bloqueado por default), no modifica consentimiento, no llama Orchestrator/MCP.',
    fields: {
      delivery_mode: { label: 'Modo', help: 'dry_run = sin envío real. test_send = envío a un contacto test. production_future = bloqueado en 15D.' },
      dry_run: { label: 'Dry-run', help: 'Valida campaña, schedule, snapshot, consent y canal. Genera plan y logs sin llamar proveedor.' },
      test_send: { label: 'Test-send', help: 'Envía a UN solo contacto test con confirmación explícita. Requiere consent opted_in.' },
      test_recipient: { label: 'Test recipient', help: 'Contacto interno designado para recibir envíos de prueba.' },
      idempotency_key: { label: 'Idempotency key', help: 'Clave única para evitar duplicados. Misma clave = mismo resultado.' },
      provider_readiness: { label: 'Provider readiness', help: 'Verifica si el proveedor de canal está configurado. Sin provider → simulación.' },
      audience_dispatch: { label: 'Envío a audiencia', help: 'Envía la campaña a todos los contactos elegibles de la audiencia vinculada. Procesado en lotes con idempotencia.' },
    },
  },
  marketing_home: {
    title: 'Marketing',
    description: 'Crea campañas desde tus leads, revisa que todo esté correcto y envía pruebas antes de activar envíos reales.',
    whatItDoesNot: 'No envía a toda la lista automáticamente — primero debes crear la campaña, revisar seguridad y hacer una prueba.',
    fields: {},
  },
  marketing_wizard: {
    title: 'Crear campaña',
    description: 'Wizard guiado para crear una campaña paso a paso: nombre, leads, mensaje, programación, revisión de seguridad y prueba.',
    whatItDoesNot: 'No envía mensajes a toda la lista. Solo permite enviar una prueba a un contacto de prueba.',
    fields: {
      campaign_name: { label: 'Nombre de campaña', help: 'Un nombre descriptivo para identificar esta campaña.' },
      objective: { label: 'Objetivo', help: 'Qué quieres lograr: promocionar, recordar, dar seguimiento, informar.' },
      lead_list: { label: 'Lista de leads', help: 'Grupo de personas a quienes podrías enviar esta campaña.' },
      message_body: { label: 'Mensaje', help: 'El texto que recibirán tus leads. Usa {{nombre}} para personalizar.' },
      test_send: { label: 'Enviar prueba', help: 'Envía un mensaje únicamente al contacto de prueba, nunca a toda la lista.' },
    },
  },
  crm_home: {
    title: 'CRM',
    description: 'Convierte leads entrantes en oportunidades, muévelas por etapas y registra tareas de seguimiento.',
    whatItDoesNot: 'No envía mensajes directamente. Para campañas usa el módulo Marketing.',
    fields: {},
  },
  crm_pipeline: {
    title: 'Pipeline',
    description: 'Vista de tus oportunidades organizadas por etapa. Mueve las oportunidades conforme avanza la negociación. Puedes configurar límites de tiempo por etapa y ver alertas si una oportunidad se queda atorada.',
    whatItDoesNot: 'No envía mensajes por sí solo — para avisos automáticos configura Automatizaciones con el evento "Oportunidad cambió de etapa" o "Oportunidad atorada en etapa".',
    fields: {},
  },
  crm_leads: {
    title: 'Leads CRM',
    description: 'Personas interesadas en tu negocio que ya están en proceso comercial.',
    whatItDoesNot: 'No es lo mismo que contactos de Marketing — son registros comerciales separados.',
    fields: {},
  },
  crm_tasks: {
    title: 'Tareas',
    description: 'Acciones pendientes para dar seguimiento a leads y oportunidades.',
    whatItDoesNot: 'No envía recordatorios automáticos ni sincroniza con calendario externo.',
    fields: {},
  },
  crm_task_templates: {
    title: 'Plantillas de tareas',
    description: 'Guarda una lista de tareas que sueles repetir (ej. "Cliente nuevo": llamar, enviar contrato, agendar) y aplícala con un clic a cualquier lead u oportunidad — crea todas las tareas de golpe, con sus fechas límite calculadas automáticamente.',
    whatItDoesNot: 'No asigna tareas a diferentes personas dentro de la misma plantilla — al aplicarla, todas quedan con el mismo responsable (o sin asignar).',
    fields: {},
  },
  crm_convert: {
    title: 'Leads pendientes',
    description: 'Leads que llegaron por Fuentes de Leads y esperan ser agregados al CRM.',
    whatItDoesNot: 'No convierte automáticamente — requiere tu revisión y aprobación.',
    fields: {},
  },
  agenda_home: {
    title: 'la Agenda',
    description:
      'Centro de citas vinculadas a tus leads del CRM. Desde aquí vas al calendario (día/semana/mes), creas citas nuevas o saltas al CRM. ' +
      'Los administradores y gerentes ven todas las citas del negocio; un vendedor solo ve las que tiene asignadas. ' +
      'Las citas que agenda la IA (voz, WhatsApp) también aparecen aquí y respetan horario de atención, bloqueos y disponibilidad del vendedor.',
    whatItDoesNot:
      'No sustituye el horario de atención del negocio (se configura en Perfil del negocio). No inventa citas: las crea un humano o la IA con herramientas de agendar.',
    fields: {
      visibility: {
        label: 'Quién ve qué',
        help: 'Dueño, admin y gerente: todas las citas. Usuario/vendedor: solo las asignadas a su usuario.',
      },
      stats: {
        label: 'Indicadores',
        help: 'Resumen del día y la semana. Las cifras respetan el mismo filtro de rol (el vendedor no cuenta citas ajenas).',
      },
    },
  },
  agenda_calendar: {
    title: 'el calendario de Agenda',
    description:
      'Un solo calendario (día, semana o mes) con tus citas y las tareas CRM del periodo. ' +
      'Puedes editar una cita, marcarla completada, no-show o cancelarla. ' +
      '“Bloquear espacio” crea ventanas donde nadie (ni la IA) puede agendar. ' +
      'Google Calendar se conecta por usuario: cada vendedor conecta el suyo para recibir las citas que le asignen.',
    whatItDoesNot:
      'No sincroniza en dos sentidos (editar en Google no cambia CavernicolApp). No muestra citas de otros vendedores si eres usuario sin rol de admin/gerente.',
    fields: {
      block_space: {
        label: 'Bloquear espacio',
        help: 'Reserva un tramo (vacaciones, junta, cierre). La IA y el sistema rechazan citas que choquen. Puedes bloquear todo el negocio o solo tu agenda.',
      },
      google_connect: {
        label: 'Conectar Google Calendar',
        help: 'Vincula tu cuenta personal de Google. Las citas asignadas a ti se publican ahí. Si no tienes Google, el sistema puede usar el calendario de otro usuario del tenant que sí esté conectado.',
      },
      views: {
        label: 'Día / Semana / Mes',
        help: 'Cambia la granularidad. En mes, un clic en el día abre la vista día con el detalle.',
      },
      roles: {
        label: 'Visibilidad por rol',
        help: 'Admin/gerente: todas las citas. Vendedor: solo las suyas. Los bloqueos de “todo el negocio” los ven todos; los personales solo el dueño del bloqueo y los admins.',
      },
      business_hours: {
        label: 'Horario de atención',
        help: 'Se configura en Perfil del negocio. La IA no debe agendar fuera de ese horario (ej. no a las 6:00 si abres a las 9:00).',
      },
    },
  },
  agenda_today: {
    title: 'Citas de hoy',
    description: 'Lista cronológica de las citas del día (misma regla de visibilidad por rol).',
    fields: {},
  },
  agenda_week: {
    title: 'Esta semana',
    description: 'Citas de los próximos 7 días agrupadas por día.',
    fields: {},
  },
  agenda_list: {
    title: 'Todas las citas',
    description: 'Lista completa filtrable por estado (admins ven todas; vendedores solo las suyas).',
    fields: {},
  },
  agenda_new: {
    title: 'una nueva cita',
    description:
      'Elige el lead del CRM, fecha/hora (hora local del negocio), duración y opcionalmente servicio, recurso y vendedor. ' +
      'El sistema valida horario de atención, bloqueos y si el vendedor ya tiene otra cita. ' +
      'Si el recurso está lleno, puedes meter al lead en lista de espera.',
    whatItDoesNot:
      'No inventa leads: debe existir en el CRM. No salta el horario de atención ni los bloqueos que configuraste.',
    fields: {
      crm_lead_id: {
        label: 'Lead',
        help: 'Persona del CRM con la que se agenda. Debe estar activa.',
      },
      crm_deal_id: {
        label: 'Oportunidad',
        help: 'Opcional. Vincula la cita a un deal abierto del lead y, si marcas la casilla, puede avanzar la etapa del pipeline.',
      },
      service_id: {
        label: 'Servicio',
        help: 'Qué se reserva (corte, consulta…). Ajusta la duración sugerida y puede exigir depósito si lo configuraste.',
      },
      resource_id: {
        label: 'Recurso',
        help: 'Quién o qué atiende: profesional, sala o equipo. Evita choques de cupo en ese recurso.',
      },
      assigned_to_user_id: {
        label: 'Vendedor asignado',
        help: 'Quién “posee” la cita en el calendario y, si tiene Google conectado, recibe el evento. Si lo dejas vacío se usa el vendedor del lead o un fallback del negocio.',
      },
      starts_at: {
        label: 'Fecha y hora',
        help: 'Hora local del negocio. Debe caer dentro del horario de atención y no chocar con bloqueos ni citas del vendedor.',
      },
      duration_minutes: {
        label: 'Duración',
        help: 'Minutos de la cita. Si elegiste servicio, se prellena con su duración típica.',
      },
      notes: {
        label: 'Notas',
        help: 'Detalle interno (servicio, preferencias). La IA de voz también puede rellenar notas al agendar.',
      },
    },
  },
  agenda_resources: {
    title: 'servicios y recursos',
    description:
      'Servicios = qué se reserva (duración, cupo, anticipación, depósito). Recursos = quién/qué atiende (profesional vinculado a un usuario, sala, equipo). ' +
      'La lista de espera promociona automáticamente si se libera un cupo. ' +
      'Los bloqueos de tiempo se gestionan en el Calendario; el horario de apertura del negocio en Perfil del negocio.',
    whatItDoesNot:
      'No es el lugar para bloquear un día completo de vacaciones — usa “Bloquear espacio” en el Calendario. No define el horario L–V (eso es Horario de atención).',
    fields: {},
  },
  agenda_block: {
    title: 'bloquear un espacio',
    description:
      'Crea una ventana donde no se puede agendar (IA ni humanos). Útil para vacaciones, juntas o cierre temporal. ' +
      'Puede aplicar a todo el negocio o solo a un vendedor.',
    whatItDoesNot: 'No cancela citas ya existentes en ese tramo; solo impide nuevas.',
    fields: {
      title: { label: 'Título', help: 'Nombre corto visible en el calendario (ej. “Vacaciones”, “Junta semanal”).' },
      starts_at: { label: 'Desde', help: 'Inicio del bloqueo en hora local.' },
      ends_at: { label: 'Hasta', help: 'Fin del bloqueo. Debe ser posterior al inicio.' },
      whole_business: {
        label: 'Todo el negocio',
        help: 'Si está marcado, nadie puede agendar en ese tramo. Si no, solo se bloquea la agenda del usuario que crea el bloqueo (vendedor).',
      },
    },
  },
  // Sprint 18 — Assignment
  assignment_config: {
    title: 'Motor de asignación',
    description: 'Configura cómo se asignan leads a agentes: manual, round robin o por menor carga. Administra equipos por línea de negocio.',
    whatItDoesNot: 'No reemplaza la lista de leads — para ver y filtrar leads ve a la pestaña Leads.',
    fields: {
      strategy: { label: 'Estrategia', help: 'Algoritmo: manual, round robin o menor carga.' },
      auto_on_inbound_convert: { label: 'Auto al convertir', help: 'Asignación automática al convertir entrante.' },
      auto_on_manual_lead: { label: 'Auto en lead manual', help: 'Asignación automática al crear lead manual.' },
      auto_pool_match: { label: 'Auto-match equipo', help: 'Match automático de leads a equipos por palabras clave de interés.' },
    },
  },
  assignment_pools: {
    title: 'Equipos de asignación',
    description: 'Agrupa agentes por especialidad o línea de negocio. Los leads se asignan dentro del equipo correspondiente.',
    whatItDoesNot: 'No limita la visibilidad — todos los usuarios CRM ven todos los leads.',
    fields: {},
  },
  assignment_reassign: {
    title: 'Reasignación',
    description: 'Cambia el agente responsable de un lead.',
    whatItDoesNot: 'No notifica al agente anterior ni al nuevo por email/WhatsApp.',
    fields: {},
  },
  assignment_leads: {
    title: 'Leads con asignación',
    description: 'Filtra leads por responsable, reasigna desde el detalle o usa el badge para identificar al agente asignado.',
    whatItDoesNot: 'La asignación no restringe visibilidad — todos los usuarios CRM ven todos los leads.',
    fields: {},
  },
  crm_export: {
    title: 'Exportar leads',
    description: 'Descarga un CSV con todos tus leads (máximo 5000). Incluye responsable, equipo, sede, fuente y estado.',
    whatItDoesNot: 'No exporta datos de oportunidades ni tareas — solo leads.',
    fields: {},
  },
  crm_contact_persistence: {
    title: 'Contacto persistente',
    description: 'Cada lead se vincula a un contacto. Si el email o teléfono ya existe, se reutiliza el mismo contacto.',
    whatItDoesNot: 'No fusiona contactos automáticamente si hay conflicto — crea uno nuevo y muestra alerta.',
    fields: {},
  },
  assignment_routing: {
    title: 'Enrutamiento por sede y campaña',
    description: 'Reglas declarativas que asignan leads a equipos según sede, medio, canal o campaña. Se evalúan por prioridad.',
    whatItDoesNot: 'No reemplaza la asignación manual — si un lead ya tiene equipo, se respeta.',
    fields: {},
  },
  triggers: {
    title: 'las automatizaciones',
    description: 'Cuando ocurre un evento (lead asignado, recordatorio de cita, etc.), el sistema puede avisar al vendedor por WhatsApp interno y registrar actividad en el CRM. Los recordatorios de cita avisan al vendedor siempre; al cliente solo si tiene consentimiento WhatsApp y tu número está conectado.',
    whatItDoesNot: 'No envía mensajes proactivos al lead sin opt-in. No reemplaza la respuesta automática del Inbox ni las campañas masivas.',
    fields: {
      notify_assigned_user_whatsapp: { label: 'WhatsApp al vendedor', help: 'Usa el WhatsApp del vendedor (Mi equipo) y el canal interno de avisos. Nunca usa el teléfono del lead.' },
      notify_lead_whatsapp: { label: 'WhatsApp al lead', help: 'Solo si el contacto tiene consentimiento activo (opt-in) en WhatsApp y tienes un número conectado para conversaciones con leads.' },
      reminder_hours: { label: 'Horas antes', help: 'Los recordatorios se envían 24 h y 2 h antes de la cita (fijo por ahora).' },
    },
  },
};

export default helpContent;
